import { useEffect, useRef, useState } from 'react';

/**
 * Mostra o loader da marca a cada troca de tela do painel.
 *
 * É o fluxo do protótipo: ao trocar de página, a área de conteúdo é coberta
 * pelo loader por um tempo visível, enquanto a barra lateral e o cabeçalho
 * ficam onde estão.
 *
 * O tempo é fixo de propósito. Amarrar o fim do loader ao carregamento real
 * daria uma duração diferente a cada clique — às vezes 20ms, às vezes 800ms —
 * e o resultado é justamente a piscada que se quer evitar. Uma duração
 * constante lê como transição; uma duração variável lê como defeito.
 *
 * A primeira renderização não conta: quem acabou de abrir o painel já esperou
 * o carregamento inicial e não deve esperar de novo.
 */
export function useTransicaoDeTela(chave: string, duracaoMs = 900): boolean {
  const [emTransicao, setEmTransicao] = useState(false);
  const anterior = useRef<string | null>(null);

  useEffect(() => {
    if (anterior.current === null) {
      anterior.current = chave;
      return;
    }
    if (anterior.current === chave) return;

    anterior.current = chave;
    setEmTransicao(true);

    const timer = setTimeout(() => {
      setEmTransicao(false);
    }, duracaoMs);
    return () => {
      clearTimeout(timer);
    };
  }, [chave, duracaoMs]);

  return emTransicao;
}
